import { useQuery } from '@tanstack/react-query';

import { ApiError, apiRequest } from '../../lib/api-client';
import type { CurrentUser } from '../../lib/api-types';

export const userKeys = { current: ['account', 'current-user'] as const };

export async function fetchCurrentUser(): Promise<CurrentUser> {
  // retrySession=false: skip the refresh-token cycle and SESSION_EXPIRED_EVENT dispatch
  // for the initial auth check. Mid-session expiry is handled by other API calls.
  return (await apiRequest<{ user: CurrentUser }>('/api/users/me', {}, false)).user;
}

export function useCurrentUser() {
  return useQuery({
    queryFn: fetchCurrentUser,
    queryKey: userKeys.current,
    retry: (failureCount, error) =>
      error instanceof ApiError && error.status === 401 ? false : failureCount < 1,
  });
}
